<template>
	<div :style="[{'margin-top': widthScale * item.marginTop + 'px' || 0},{'margin-bottom': widthScale * item.marginBottom + 'px' || 0}]">
    <!-- 秒杀样式1 -->
    <div v-if="item.style == 6" class="index-seckill" :style="[{'background-image':'url('+(list.length>1?item.baseImage2Url:item.baseImageUrl)+')'},{'height':Math.floor(list.length==1? widthScale*384: widthScale*480)+ 'px' }]">
      <div class="index-seckill-head" v-if="item.hideInfo != 1">
        <div class="index-seckill-title">
          <div class="t1">
            <img src="@/assets/home/kill-title.png" alt="">
          </div>
          <van-count-down use-slot :time="time" @click="onTimeChange" v-if="item.showCountDown == 1&&time&& time/1000/3600 < 100">
            <template slot-scope="timeData">
              <div class="time-wrap">
                <div class="t2">
                  {{getTime(timeData.hours)}}
                </div>
                <div class="t2-i">:</div>
                <div class="t2">
                  {{getTime(timeData.minutes)}}
                </div>
                <div class="t2-i">:</div>
                <div class="t2">
                  {{getTime(timeData.seconds)}}
                </div>
              </div>
            </template>
          </van-count-down>
        </div>
        <div class="index-seckill-right">
          <div class="index-seckill-tabs">
            <div class="index-seckill-tabs-content" id="tabs">
              <div class="index-seckill-tab" :class="{'tab-active': tabActive == index}" v-for="(tab, index) in item.seckillActivityList" :key="index" @click="toggleTab(index, $event, tab)">
                <div class="t3">{{tab.title}}</div>
                <div class="t4">{{tab.statusDesc}}</div>
              </div>
            </div>
          </div>
          <img class="next" @click="onJumpToOther(item)" src="../../assets/image/arrow_icon@2x.png" />
        </div>
      </div>
      <div>
        <div :class="[list.length >= 3 ? 'seckill-list-box' : '']">
          <div :class="['seckill-list', 'seckill-list-' + getClass(list.length)]" @scroll="onScroll">
            <div class="goods-box" v-for="(item, index) of list" :key="index">
              <div class="goods" @click="onJumpToGoodsDetail(item, index)">
                <div class="img-box">
                  <van-image :src="item.indexImageUrl && item.indexImageUrl + '?x-oss-process=style/style_index_flashsale'" fit="cover"/>
                  <van-image class="photo" v-if="item.cornerMark && item.cornerMark.photoFrameImageUrl" :src="item.cornerMark.photoFrameImageUrl + '?x-oss-process=style/style_index_flashsale'" fit="cover"/>
                </div>
                <div class="describe">
                  <div v-if="list.length > 1" class="progress">
                    <van-progress color="#ed3939" :percentage="getPercentage(item)" :show-pivot="false"></van-progress>
                  </div>
                  <div class="goods-name">{{item.goodsName}}</div>
                  <div class="sell-prop">{{item.sellProp}}</div>
                  <div v-if="list.length == 1" class="one-progress">
                    <div class="progress-box">
                      <van-progress color="#ed3939" :percentage="getPercentage(item)" :show-pivot="false" stroke-width="7"></van-progress>
                    </div>
                    <span>{{getProgressNum(item)}}%</span>
                  </div>
                  <div class="price">
                    <span class="goods-price">
                      <span v-if="list.length == 1" class="name">秒杀价：</span>
                      <i>￥</i>{{item.goodsPrice}}
                    </span>
                    <span class="market-price">￥{{item.markingPrice}}</span>
                    <img class="rob" src="@/assets/home/rob.png" alt="">
                    <span v-if="list.length == 1" class="now-rob">马上抢</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="scroll-bar" v-if="list.length > 3">
          <span><i :style="{transform: 'translateX('+scrollBarPosition+'%)'}"></i></span>
        </div>
      </div>
    </div>

    <!-- 秒杀样式2 -->
    <div v-else-if="item.style == 7">
      <div :class="['styleTwo', 'styleTwo-' + getClass(item.seckillActivityList.length)]">
        <div class="_left"  @scroll="onScroll">
          <div
          :class="['item-box']"
          v-for="(target, index) of item.seckillActivityList"
          :key="index"
          >
            <img class="bg" v-if="index == 0" :src="item.seckillComponentStyle2.leftBgImageUrl" alt="">
            <img class="bg" v-else :src="item.seckillComponentStyle2.rightBgImageUrl" alt="">
            <div class="item">
              <div class="title">
                <span :class="['hours', index == 0 ? 'first-hours' : '']">{{getHours(target.title)}}</span>
                <div class="timer" v-if="target.visibleCountDown">
                  <van-count-down :time="target.seconds" use-slot @finish="onCountDownFinish(index)">
                    <template slot-scope="timeData">
                      <div class="time-wrap">
                        <div class="t2">
                          {{getTime(timeData.hours)}}
                        </div>
                        <div class="t2-i">:</div>
                        <div class="t2">
                          {{getTime(timeData.minutes)}}
                        </div>
                        <div class="t2-i">:</div>
                        <div class="t2">
                          {{getTime(timeData.seconds)}}
                        </div>
                      </div>
                    </template>
                  </van-count-down>
                </div>
                <div class="timer date" v-else-if="target.started">抢购中</div>
                <div class="timer date" v-else>{{getMonthDay(target.startTime)}}</div>
              </div>
              <div :class="['goods-' + getClass(target.seckillActivityGoodsList.length)]">
                <div class="goods-scroller" @scroll="onGoodsScroll($event, index)">
                  <div
                  :class="['goods', goods.buttonStatus == 1 ? 'no-stock' : '', goods.buttonStatus == 4 ? 'reminded' : '']"
                  v-for="(goods, idx) of target.seckillActivityGoodsList"
                  :key="goods.seckillId"
                  @click="onJumpToGoodsDetail(goods, idx)"
                  >
                    <div class="img-box">
                      <van-image class="goods-img" v-if="goods.indexImageUrl" :src="goods.indexImageUrl + '?x-oss-process=style/style_index_flashsale'" fit="cover"/>
                      <van-image class="goods-img photo" v-if="goods.cornerMark && goods.cornerMark.photoFrameImageUrl" :src="goods.cornerMark.photoFrameImageUrl + '?x-oss-process=style/style_index_flashsale'" fit="cover"/>
                      <!-- <div class="status brand-name" v-if="target.seckillActivityGoodsList.length == 1">{{goods.brandName}}</div> -->
                      <template v-if="target.seckillActivityGoodsList.length > 1">
                        <div
                        class="status qiang"
                        v-if="[1, 2].includes(goods.buttonStatus)"
                        >
                          {{goods.buttonStatus == 1 ? '已抢完' : '马上抢'}}
                        </div>
                        <div
                        class="status remind"
                        v-if="[3, 4].includes(goods.buttonStatus)"
                        @click.stop="onSeckillTixing(goods, index, idx)"
                        >
                          {{goods.buttonStatus == 3 ? '提醒我' : '已设提醒'}}
                        </div> 
                      </template>
                    </div>
                    <div class="desc">
                      <div class="name">{{goods.goodsName}}</div>
                      <div class="price"><span>￥</span>{{goods.goodsPrice}}</div>
                      <div class="btn-box">
                        <button v-if="[1, 2].includes(goods.buttonStatus)" class="qiang">
                          <div class="icon"><img src="@/assets/home/style-two-qiang.png" alt=""></div>{{goods.buttonStatus == 1 ? '已抢完' : '马上抢'}}
                        </button>
                        <button v-if="[3, 4].includes(goods.buttonStatus)" class="remind" @click.stop="onSeckillTixing(goods, index, idx)">
                          <div class="icon"><img src="@/assets/home/style-two-clock.png" alt=""></div>{{goods.buttonStatus == 3 ? '提醒我' : '已设提醒'}}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="scroll-bar" v-if="target.seckillActivityGoodsList.length >= 3">
                  <span><i :style="{transform: 'translateX('+target.scrollBarPosition+'%)'}"></i></span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="scroll-bar" v-if="item.seckillActivityList.length >= 3">
          <span><i :style="{transform: 'translateX('+scrollBarPosition+'%)'}"></i></span>
        </div>

        <div
        class="_right"
        v-if="item.seckillActivityList.length == 1 && item.seckillComponentStyle2"
        @click="onJumpTo"
        >
          <img class="bg" :src="item.seckillComponentStyle2.branchBgImageUrl" alt="">
          <img class="branch-ad-image" :src="item.seckillComponentStyle2.branchAdImageUrl" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/utils/axios";
import utils from '@/utils/common';
export default {
	props: {
		contentPageId: {
			default: 0,
			type: Number
		},
		item: {
			type: Object,
			default: function() {
				return {}
			}
		},
		sort: {
			default: 0,
			type: Number
		},
		refresh: {
			default: false,
			type: Boolean
		}
	},
	data() {
		return {
			widthScale:  window.innerWidth / 750,
			tabActive: 0,
			time: 0,
			timeData: {},
			list: [],
      scrollBarPosition: 0
		}
  },
	mounted() {
		gio("track", "moduleExposure", {indexId_var: String(this.contentPageId), entryType_vara:'限时秒杀', entryType_floor_var: String(this.sort)});
		this.list = this.item.seckillActivityGoodsList;
		if(this.item.showCountDown == 1 && this.item.hideInfo != 1) {
      this.time = this.item.seckillActivityList.find(item=>item.isSelect == 1).nextStartMillisecond;
		}
		this.toggleTab(this.item.seckillActivityList.findIndex(item=>item.isSelect == 1));
	},
	watch: {
		refresh: function(val) {
			if(val) {
				this.list = this.item.seckillActivityGoodsList;
				if(this.item.showCountDown == 1 && this.item.hideInfo != 1) {
					this.time = this.item.seckillActivityList.find(item=>item.isSelect == 1).nextStartMillisecond;
				}
				this.toggleTab(this.item.seckillActivityList.findIndex(item=>item.isSelect == 1));
			}
		}
	},
	methods: {
		nextTab() {},
		getClass(length) {
			return `${ ({"1": "one", "2": "two"})[length] || 'three' }`
		},
		getPercentage(item) {
			return Math.max(0, ((item.totalStock - item.currentStock) / item.totalStock).toFixed(2) * 100)
    },
    getProgressNum: function(item) {
      const num = ((item.totalStock - item.currentStock) / item.totalStock * 100).toFixed(0)
      return num <= 0 || isNaN(num) ? 0 : num
    },
		onTimeChange(e) {
			this.timeData = e.detail;
		},
		getTime(time) {
			return time < 10 ? '0' + time : time
    },
    getHours(value) {
      value = value || ''
      if(value.indexOf(':') > -1) {
        return Number(value.split(':')[0]) || 0
      }
      return ''
    },
    getMonthDay(value) {
      let result = ''
      try {
        if(value) {
          const [year, month, day] = value.split(' ')[0].split('-')
          result = `${month}月${day}日`
        }
      } catch(e) {}
      return result
    },
    onCountDownFinish(index) {
      this.item.seckillActivityList[index].visibleCountDown = false
      this.item.seckillActivityList[index].started = true
    },
		onJumpToGoodsDetail(item, index) {
			gio("track", "flowLocationClick", {indexId_var: String(this.contentPageId), entryType_vara:'限时秒杀', entryType_floor_var: String(this.sort), position_var:String(index), sort_var:'', positonName_var:item.goodsName});
			// this.$router.push({
			// 	path: "/commoditydetails",
			// 	query: { id: item.goodsId }
			// });
       var obj = {goodsId:parseInt(item.goodsId)};
         utils.jumpToNewPage({
                    url: window.location.origin + "/h5user/commoditydetails?id=" +  item.goodsId,
                    noTitle: "0",
                    action:{tm:"4030100",tp:obj}
        });


			utils.nativeMethod({tm:'4000101',tp:{module_evar: '限时秒杀'}})
		},
		onJumpToOther(item) {
			if (item.seckillLinkUrl) {
				let params = {}
				item.seckillLinkUrl.split('?')[1] && item.seckillLinkUrl.split('?')[1].split('&').forEach(item => {
					let strArr = item.split('=');
					params[strArr[0]] = strArr[1];
				});
				utils.jumpToNewPage({
					url: item.seckillLinkUrl,
					barColor: params.naviBarColor && '#' + params.naviBarColor
				});
			}
    },
    onSeckillTixing(goods, index, idx) {
      //buttonStatus 1=去看看(表示秒杀商品卖完了)，2=去抢购，3=提醒我(秒杀未开始，并且未添加提醒)，4=取消提醒(秒杀未开始且已添加提醒)
      if(goods.buttonStatus == 4) {
        return this.$toast("在开抢前五分钟会提醒你哦！");
      }
      if(goods.buttonStatus != 3) return;
      http({
        url: "order/user/seckill/follow/" + goods.seckillId,
        method: "put"
      }).then(rps => {
        if (rps.code === 200) {
          this.$toast("添加提醒成功");
          this.item.seckillActivityList[index].seckillActivityGoodsList[idx].buttonStatus = 4
        }
      });
    },
    onJumpTo() {
      const item = this.item.seckillComponentStyle2
      switch(item.linkCode) {
        // 不跳转
        case 'NONE': 
          break;
        // 链接
        case 'LINK': 
          if (item.linkValue) {
            let params = {}
            item.linkValue.split('?')[1] && item.linkValue.split('?')[1].split('&').forEach(item => {
              let strArr = item.split('=');
              params[strArr[0]] = strArr[1];
            });
            utils.jumpToNewPage({
              url: item.linkValue,
              barColor: params.naviBarColor && '#' + params.naviBarColor
            });
          }
          break;
        // 店铺
        case 'BRANCH': 
          utils.jumpToNewPage({
            url: window.location.origin +'/h5user/brandindex?id=' + item.linkValue,
            noTitle: '1',
             action:{tm:"4090100",tp:{branchId:parseInt(item.linkValue)}}
          });
          break;
      }
    },
		getGoodsList(parmes) {
			http({
				url: '/order/app/seckill/getGoodsList',
				method: 'post',
				parmes
			}).then(rps=>{
				if(rps.code == 200) {
          this.$loading.hide();
          /**
           * 解决苹果手机一个很诡异bug
           * 如果直接this.list = rps.data; markingPrice的值不会更新
           */
          this.list = [];
          this.$nextTick(() => {
            this.list = rps.data;
          })
				}
			})
		},
		toggleTab(index, e, data) {
			if(this.item.hideInfo == 1) return
			this.tabActive = index;
			this.$nextTick(()=>{
        let nav = document.getElementById('tabs');

        if(!nav) return

				let	clientWidth = document.getElementsByClassName('index-seckill-tabs')[0].clientWidth / 2;
        let target;
        
				if(e) {
					target = e.target
				} else {
					target = document.getElementsByClassName('index-seckill-tab tab-active')[0]
				}

				let allwidth = nav.clientWidth,
					diffWidth = clientWidth - target.offsetWidth / 2,
					offsetWidth = target.offsetLeft,
					targetOffset = offsetWidth - diffWidth;
				nav.scrollLeft = targetOffset;
			})

			if(e) {
				this.getGoodsList({startTime: data.startTime, endTime: data.endTime});
			}
		},
		onScroll(e) {
			const { scrollLeft, scrollWidth, offsetWidth } = e.target
			this.scrollBarPosition = Math.floor((scrollLeft / (scrollWidth - offsetWidth)) * 77)
    },
    onGoodsScroll(e, index) {
      const { scrollLeft, scrollWidth, offsetWidth } = e.target
      this.item.seckillActivityList[index].scrollBarPosition = Math.floor((scrollLeft / (scrollWidth - offsetWidth)) * 94)
    }
	}
}
</script>

<style lang="less" scoped>
.index-seckill {
	padding-top: 40px;
	background-size: 100% 100%;
	background-repeat: no-repeat;
	box-sizing: border-box;
	.index-seckill-head, .index-seckill-title, .index-seckill-tabs, .index-seckill-tabs-content, .progress-warp {
		display: flex;
	}
	.index-seckill-head {
		justify-content: space-between;
		align-items: center;
		margin-bottom: 11px;
		padding-left: 30px;
		padding-right: 20px;
	}
	.index-seckill-right {
		display: flex;
		flex-wrap: nowrap;
		align-items: center;
	}
	.index-seckill-tabs {
		width: 275px;
		overflow: hidden;
		// padding: 0 10px;
	}
	.index-seckill-tabs-content {
		// width: 500px;
		position: relative;
		overflow-x: auto;
		&::-webkit-scrollbar {display:none}

		.index-seckill-tab.tab-active {
			.t3, .t4 {
				color: red;
			}
		}
	}
	.index-seckill-tab {
		padding: 0 10px;
		text-align: center;
	}
	.seckill-list {
		display: flex;
		padding-top: 10px;
		padding-bottom: 30px;
		.goods-box {
			flex: 1;
			box-sizing: border-box;
			overflow: hidden;
		}
		.goods-name {
      font-size: 20px;
      font-weight: bold;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
		}
		.img-box {
			overflow: hidden;
      margin: 0 auto;
      position: relative;
    }
    .photo {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
    }
    .van-image {
      width: 100%;
    }
		.goods-price {
			font-size: 29px;
			color: #F02610;
			font-weight: bold;
			i {
				font-style: normal;
				font-size: 22px;
			}
		}
		.market-price {
			font-size: 20px;
      color: #B3B3B3;
			text-decoration: line-through;
		}
		.sell-prop {
			display: none;
		}
	}
	.seckill-list-one {
		padding-left: 30px;
		padding-right: 30px;
		.goods {
			display: flex;
		}
		.img-box {
			width: 215px;
			height: 215px;
		}
		.describe {
			flex: 1;
			box-sizing: border-box;
			padding-left: 40px;
			position: relative;
		}
		.one-progress {
			width: 282px;
			display: flex;
			margin-top: 14px;
			.progress-box {
				flex: 1;
				display: flex;
				align-items: center;
				box-sizing: border-box;
				padding-right: 15px;
			}
			.van-progress {
				width: 100%;
			}
			span {
				font-size: 24px;
				color: #B3B3B3;
			}
		}
		.goods-name {
			font-size: 30px;
			width: 329px;
			white-space: nowrap;
			text-overflow: ellipsis;
			overflow: hidden;
		}
		.sell-prop {
			display: block;
			font-size: 24px;
			color: #B4B4B4;
			margin-top: 4px;
			overflow : hidden;
			max-height: 104px;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-line-clamp: 3;
			-webkit-box-orient: vertical;
		}
		.rob {
			display: none;
		}
		.price {
			position: absolute;
			left: 40px;
			right: 0;
			bottom: 0;
			z-index: 1;
      font-size: 44px;
      height: 94px;
    }
    .name {
      font-size: 28px;
      font-weight: normal;
    }
		.goods-price {
      font-size: 44px;
      position: absolute;
      left: 0;
      bottom: 0;
      z-index: 1;
			i {
        font-size: 28px;
        font-weight: normal;
			}
    }
    .market-price {
      position: absolute;
      top: 0;
      z-index: 1;
      font-size: 22px;
      
    }
		.now-rob {
			position: absolute;
			right: 4px;
			bottom: 6px;
			z-index: 1;
			padding: 8px 20px;
			color: #FFFFFF;
			background: #F02610;
			font-size: 20px;
			font-weight: bold;
			border-radius: 26px;
		}
	}
	.seckill-list-two {
		padding-left: 26px;
		padding-right: 26px;
		.goods-box {
			width: 50%;
			overflow: hidden;
			padding: 0 22px
		}
		.img-box {
			width: 302px;
			height: 300px;
			overflow: hidden;

		}
		.progress {
			padding: 8px;
		}
		.goods-name, .price {
			display: none;
		}
	}
	.seckill-list-box {
		overflow: hidden;
    height: 327px;
    margin: 0 30px;
	}
	.seckill-list-three {
		padding-bottom: 0;
		display: block;
		white-space: nowrap;
		max-width: 100%;
		overflow-x: auto;
		overflow-y: hidden;
		-webkit-overflow-scrolling: touch;
		height: 344px;
		box-sizing: border-box;
		.goods-box {
      padding-right: 22.5px;
      display: inline-block;
    }
    .goods-box:last-child {
      padding-right: 0;
    }
    .goods {
      width: 215px;
    }
		.price {
			position: relative;
			font-size: 29px;
			margin-top: 6px;
		}
		.rob {
			position: absolute;
			top: 50%;
			right: 0;
			z-index: 1;
			width: 52px;
			height: 30px;
			margin-top: -15px;
		}
		.progress {
			padding: 10px 8px;
		}
		.goods-name {
			font-size: 20px;
			font-weight: bold;
		}
		.goods-price {
			font-size: 29px;
			color: #F02610;
		}
		.market-price {
			font-size: 20px;
			color: #B3B3B3;
			text-decoration: line-through;
		}
		.img-box {
			width: 215px;
			height: 215px;
		}
	}
}
.t1 {
	font-size: 28px;
	line-height: 40px;
	font-weight: 500;
	margin-right: 20px;
	img {
		width: 117px;
		height: 40px;
	}
}
.time-wrap {
	height: 40px;
	line-height: 40px;
	display: flex;
	align-items: center;
}
.t2 {
	font-size: 28px;
	// display: inline-block;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 40px;
	height: 40px;
	background-color: #ED3939;
	border-radius: 10px;
	// text-align: center;
	line-height: normal!important;
	font-weight: 500;
	color: #fff;
}
.t2-i {
	height: 40px;
	line-height: 40px;
	color: #ccc;
	margin: 0 6px;
	font-style: normal;
	font-size: 28px;
}
.t3 {
	font-size: 24px;
	line-height: 28px;
	font-weight: 500;
	color: #999;
}
.t4 {
	font-size: 20px;
	line-height: 33px;
	font-weight: 400;
	color: #999;
	white-space: nowrap;
}
.price-1 {
	color: #E83636;
	font-weight: 500;
}
.price-2 {
	color: #ccc;
	font-weight: 400;
	margin-left: 10px;
	text-decoration: line-through;
}
.next, .prev {
	display: inline-block;
	width: 40px;
	height: 40px;
	color: #999;
	margin-left: 10px;
}
.btn1 {
	width: 128px;
	height: 44px;
	line-height: 44px;
	border-radius: 22px;
	background-color: #ED3939;
	border: none;
	text-align: center;
	font-size: 24px;
	font-weight: 500;
	color: #fff;
	/deep/ .van-button__text {
		display: inline-block;
		white-space: nowrap;
	}
}
button {
  outline: none;
  border: 0;
}
.scroll-bar {
	text-align: center;
	font-size: 12px;
	margin-top: 30px;
	span {
		display: inline-block;
		height: 8px;
		width: 90px;
		border-radius: 4px;
		position: relative;
		font-size: 0;
		background: #ebedf0;
	}
	i {
		position: absolute;
		top: 0;
		left: 0;
		z-index: 1;
		display: inline-block;
		width: 50px;
		height: 8px;
		background: green;
		border-radius: 4px;
		font-size: 0;
		background: linear-gradient(180deg,rgba(255,53,27,1) 0%,rgba(240,38,16,1) 100%);
	}
}
.styleTwo {
  font-size: 28px;
  .scroll-bar {
    margin-top: 0;
  }
  ._left {
    white-space: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .item-box {
    display: inline-block;
    position: relative;
    width: 340px;
    height: 236px;
    box-sizing: border-box;
  }
  .bg {
    width: 340px;
    height: 236px;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
  }
  .item {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
  }
  .title {
    height: 66px;
    position: relative;
  }
  .hours {
    font-size: 28px;
    font-weight: bold;
    color: #FF2F02;
    position: absolute;
    top: 0;
    right: 300px;
    height: 66px;
    display: flex;
    align-items: center;
  }
  .first-hours {
    right: 182px;
  }
  .timer {
    position: absolute;
    top: 0;
    right: 10px;
    height: 66px;
    display: flex;
    align-items: center;
    .t2 {
      width: 30px;
      height: 30px;
      font-size: 20px;
    }
    .t2-i {
      color: #FF2F02;
      margin: 0 2px;
    }
  }
  .date {
    font-size: 24px;
    color: #FF2F02;
    font-weight: bold;
  }
  .goods {
    .img-box, .goods-img {
      width: 145px;
      height: 112px;
    }
    .img-box {
      overflow: hidden;
      position: relative;
      border-radius: 10px;
    }
    .photo {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
    }
    .status {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 3;
      height: 28px;
      background: linear-gradient(270deg, #FF004E 0%, #FF9600 100%);
      color: #fff;
      font-size: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .brand-name {
      background: rgba(0, 0, 0, 0.5);
    }
    .goods-img {
      object-fit: cover;
    }
    .price {
      color: #FF2F02;
      font-size: 32px;
      font-weight: bold;
      text-align: center;
      span {
        font-size: 20px;
      }
    }
  }
  .goods-one .goods-scroller {
    margin: 0 10px;
    border-radius: 10px;
    overflow: hidden;
  }
  .goods-one .goods{
    display: flex;
    padding: 10px;
    .img-box, .goods-img {
      width: 140px;
      height: 140px;
    }
    .desc {
      width: 170px;
      box-sizing: border-box;
      padding-left: 16px;
      overflow: hidden;
      position: relative;
    }
    .name {
      font-size: 24px;
      font-weight: bold;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      margin-bottom: 5px;
      color: #333333;
    }
    .price {
      text-align: left;
      margin-left: -2px;
    }
    .btn-box {
      position: absolute;
      left: 16px;
      bottom: 0;
      z-index: 1;
    }
    button {
      width: 136px;
      height: 40px;
      background: linear-gradient(270deg, #FF004E 0%, #FF9600 100%);
      color: #fff;
      font-size: 20px;
      border-radius: 20px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      box-sizing: border-box;
      position: relative;
      padding-right: 22px;
    }
    .icon {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: #FF9438;
    }
  }
  .goods-three, .goods-two {
    padding: 11px;
    position: relative;
    .goods-scroller {
      white-space: nowrap;
      overflow-x: auto;
      overflow-y: hidden;
      -webkit-overflow-scrolling: touch;
      box-sizing: border-box;
      &::-webkit-scrollbar {
        display: none;
      }
    }
    .scroll-bar {
      margin-top: 0;
      position: absolute;
      left: 50%;
      bottom: 6px;
      margin-left: -28px;
      span {
        width: 56px;
        height: 6px;
      }
      i {
        width: 28px;
        height: 6px;
      }
    }
    .goods {
      display: inline-block;
      margin-right: 10px;
      &:first-child {
        margin-left: 10px;
      }
    }
    .name,.btn-box {
      display: none;
    }
  }
  .no-stock {
    .img-box .qiang {
      background: rgba(153,153,153, .8);
    }
    .btn-box {
      .qiang {
        background: #D2D2D2;
        .icon {
          background: #DADADA!important;
        }
      }
    }
  }
  .reminded {
    .img-box .remind {
      background: rgba(153,153,153, .8);
    }
    .btn-box {
      .remind {
        background: #D2D2D2;
        padding-right: 12px;
        .icon {
          background: #DADADA!important;
        }
      }
    }
  }
}
.styleTwo-one {
  display: flex;
  padding-left: 20px;
  >div {
    width: 340px;
    position: relative;
    height: 236px;
    margin-left: 10px;
  }
  .branch-ad-image {
    position: absolute;
    top: 66px;
    left: 10px;
    z-index: 2;
    width: 320px;
    height: 160px;
  }
}
.styleTwo-two {
  padding-left: 20px;
  .item-box {
    margin-left: 10px;
  }
}
.styleTwo-three {
  ._left {
    padding: 0 25px;
  }
  .item-box {
    margin: 0 5px;
  }
}

</style>